import axios from 'axios';
import { getAuthenticated, postAuthenticated } from './http';

const GATHERING_INVITATIONS_API_BASE = '/api/invitations/gathering';

export const fetchGatheringInvitation = async (token) => {
  const response = await axios.get(
    `${GATHERING_INVITATIONS_API_BASE}/${encodeURIComponent(token)}`
  );

  return response.data;
};

export const fetchLegacyGatheringInvitation = async (nightId) => {
  const response = await axios.get(
    `${GATHERING_INVITATIONS_API_BASE}/night/${encodeURIComponent(nightId)}`
  );

  return response.data;
};

export const acceptGatheringInvitation = (token) =>
  postAuthenticated(
    `${GATHERING_INVITATIONS_API_BASE}/${encodeURIComponent(token)}/accept`,
    {}
  );

export const acceptLegacyGatheringInvitation = (nightId) =>
  postAuthenticated(
    `${GATHERING_INVITATIONS_API_BASE}/night/${encodeURIComponent(nightId)}/accept`,
    {}
  );

export const fetchAuthenticatedGatheringInvitation = (token) =>
  getAuthenticated(`${GATHERING_INVITATIONS_API_BASE}/${encodeURIComponent(token)}`);
